<template>
	<div class="series-wrap sidebar-post-wrap">
		<div class="sidebar-post-single" @click="selected = index" :class="{selected:index == selected}" v-for="(item, index) in items" :key="index">
			<div class="sidebar-post-header">
				<h3>Part {{ index+1 }}</h3>
			</div><!-- /. sidebar-post-body -->

			<div class="sidebar-post-body">
				<a href="#">
					<img :src="require(`@/assets/images/posts-img/${item.img}`)"  />
					<h2>{{ item.title }}</h2>
					<p>{{ item.desc }}</p>
					<small>{{ item.time }}</small>
				</a>
			</div><!-- /. sidebar-post-body -->
		</div><!-- /. sidebar-post-single -->
	</div>
</template>

<script>
  export default {
      	name: "sidebar-series",

		data(){
		    return{
		    	selected:1,
		    	selectedSeries:false,
		    	items:[
		    		{
		    			id:1,
		    			img: 'sp1.svg',
		    			title: 'The Hidden Story of Charlie…',
		    			desc: 'Story series about Tom Riddle aka Lord Voldemort, a huge villain of Harry Potter Story series about Tom Riddle aka Lord Voldemort, a huge villain of Harry Potter',
		    			time: '12 days ago'
		    		},
		    		{
		    			id:2,
		    			img: 'sp1.svg',
		    			title: 'The Hidden Story of Charlie…',
		    			desc: 'Story series about Tom Riddle aka Lord Voldemort, a huge villain of Harry Potter Story series about Tom Riddle aka Lord Voldemort, a huge villain of Harry Potter',
		    			time: '12 days ago'
		    		}
		    	]
		    }
		},

		methods: {


		}
  }

</script>